import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

import {
  ListItem,
  ListItemButton,
  Stack,
  Typography,
  Divider as ListDivider,
  Grid,
} from '@mui/material';

import AvatarWithStatus from './AvatarWithStatus';
import { formatTimestamp } from 'app/helpers/timestampHelpers';
import useChatFunctions from '../hooks/useChatFunctions';
import { currentContactSelector } from '../nfChatSlice';

const ContactListItem = ({ contact, advisor }) => {
  const { setCurrentContactBySlug } = useChatFunctions();
  const currentContact = useSelector(currentContactSelector);
  const selected = currentContact?.id === contact?.id;

  return (
    <>
      <ListItem
        className="CONTACT-LIST-ITEM"
        sx={{
          padding: 0,
          margin: 0,
          width: '100%',
        }}
      >
        <ListItemButton
          onClick={() => {
            setCurrentContactBySlug(contact.other_user.slug);
          }}
          color="neutral"
          sx={{
            flexDirection: 'column',
            alignItems: 'initial',
            backgroundColor: selected ? 'rgb(245, 245, 254)' : 'inherit',
          }}
        >
          <Grid container>
            {/* LINEHAN - I wanted to fix the width of this avatar grid item,
            and have the sibling grid item grow when the window resizes, but
            wasn't able to get it to work very well. I tried xs and xs="auto"
            but was still having layout difficulties. ping me and I can show
            you what I wanted the layout to look like */}
            <Grid item xs={2} sx={{ width: '50px' }}>
              <AvatarWithStatus contact={contact} advisor={advisor} />
            </Grid>
            <Grid item xs={10}>
              <Stack direction="column" sx={{ paddingLeft: 1 }}>
                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                  <Typography
                    sx={{
                      fontSize: '1.063em',
                      fontWeight: contact.unread_messages ? 'bold' : 'normal',
                    }}
                  >
                    {contact.other_user.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    noWrap
                    sx={{
                      textAlign: 'right',
                      display: {
                        xs: 'none',
                        md: 'block',
                      },
                    }}
                  >
                    {formatTimestamp(contact.last_activity_at)}
                  </Typography>
                </Stack>
                <Typography
                  variant="body3"
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {contact.last_message_content}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </ListItemButton>
      </ListItem>
      <ListDivider sx={{ margin: 0 }} />
    </>
  );
};

ContactListItem.defaultProps = {
  advisor: null,
};

ContactListItem.propTypes = {
  contact: PropTypes.object.isRequired,
  advisor: PropTypes.object,
};

export default ContactListItem;
